import styled from 'styled-components';
import { Button } from '@bancobarigui/barihaus';

export const ReportsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;

  h1 {
    font-family: var(--typography-font-family-fontfamily, 'Nunito', sans-serif);
    font-size: var(--typography-font-size-fontsizeheadingmd, 32px);
    font-weight: var(--typography-font-weight-fontweightregular, 400);
    line-height: 1.2;
    color: var(--colors-neutral-text-colortext-dark, #000);
    margin: 0;
  }
`;

export const ReportsFormWrapper = styled.div`
  width: 441px;

  .ant-select {
    width: 441px;
    height: 45px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const ReportNMPFormItem = styled.div`
  .ant-form-item {
    margin-top: 32px;
  }

  .ant-picker {
    width: 441px !important;
    height: 45px;
  }
`;

export const ReportButtonWrapper = styled.div`
  margin-top: var(--space-padding-padding2xl, 40px);
`;

export const ReportButton = styled(Button)`
  width: 441px !important;
  height: 45px !important;
`;

export const ReportAlertWrapper = styled.div`
  position: fixed;
  top: 80px;
  right: 24px;
  z-index: 1000;

  .ant-alert {
    width: 40vw;
  }
`;
